module.exports = __webpack_public_path__ + "img/zillow_logo.211cc7aa.svg";